import { render, staticRenderFns } from "./RegistroViajerosAgencia.vue?vue&type=template&id=1bca490f&scoped=true"
import script from "./RegistroViajerosAgencia.vue?vue&type=script&lang=js"
export * from "./RegistroViajerosAgencia.vue?vue&type=script&lang=js"
import style0 from "./RegistroViajerosAgencia.vue?vue&type=style&index=0&id=1bca490f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bca490f",
  null
  
)

export default component.exports